import getStateLicenseType from 'data/LicenseTypes/getStateLicenseType';
import { applyByKey } from 'utils/reducerHelpers';
import moment from 'moment';
import initialState from './licenses.initialState';
import {
  LOAD_LICENSES_START,
  LOAD_LICENSES_SUCCESS,
  LOAD_LICENSES_ERROR,
  LOAD_SINGLE_LICENSE_START,
  LOAD_SINGLE_LICENSE_SUCCESS,
  LOAD_SINGLE_LICENSE_ERROR,
  POST_LICENSE_START,
  POST_LICENSE_SUCCESS,
  POST_LICENSE_RESET,
  EDIT_LICENSE_START,
  EDIT_LICENSE_SUCCESS,
  DELETE_LICENSE_START,
  DELETE_LICENSE_SUCCESS
} from './licenses.actions';

export default function licensesReducer(state = initialState, action) {
  const { key } = action;

  switch (action.type) {
    case LOAD_LICENSES_START:
      return applyByKey(key, state, () => ({
        loading: true,
      }));

    case LOAD_LICENSES_ERROR:
      return applyByKey(key, state, () => ({
        loading: false,
        licenseArray: undefined
      }));

    case LOAD_LICENSES_SUCCESS:
    {
      return applyByKey(key, state, () => ({
        loading: false,
        licenseArray: action.response.data.Licenses.map((license) => {
          const stateLicenseType = getStateLicenseType(license.RegionId);
          const expirationDate = license.ExpirationDate != null ? moment(license.ExpirationDate).toDate() : null;
          return {
            LicenseUid: license.LicenseUid,
            LicenseNumber: license.LicenseNumber,
            RegionID: license.RegionId,
            LicenseTypeID: license.LicenseTypeId,
            DoesNotExpire: license.DoesNotExpire,
            EffectiveDate: moment(license.EffectiveDate).toDate(),
            ExpirationDate: expirationDate,
            RegionName: stateLicenseType.RegionName,
            LicenseName: stateLicenseType.LicenseName,
          };
        })
      }));
    }

    case LOAD_SINGLE_LICENSE_START:
      return applyByKey(key, state, () => ({
        loading: true
      }));

    case LOAD_SINGLE_LICENSE_ERROR:
      return applyByKey(key, state, () => ({
        loading: false,
        license: undefined
      }));

    case LOAD_SINGLE_LICENSE_SUCCESS:
    {
      const license = action.response.data;
      const stateLicenseType = getStateLicenseType(license.RegionId);
      const effectiveDateUtc = moment.utc(license.EffectiveDate);
      const effectiveDate = new Date(effectiveDateUtc.year(),effectiveDateUtc.month(),effectiveDateUtc.date());
      const expirationDateUtc = license.ExpirationDate != null ? moment.utc(license.ExpirationDate) : null;
      const expirationDate = expirationDateUtc != null ? new Date(expirationDateUtc.year(), expirationDateUtc.month(), expirationDateUtc.date()) : null;
      return applyByKey(key, state, () => ({
        loading: false,
        license: {
          LicenseUid: license.LicenseUid,
          LicenseNumber: license.LicenseNumber,
          RegionId: license.RegionId,
          LicenseTypeId: license.LicenseTypeId,
          DoesNotExpire: license.DoesNotExpire,
          EffectiveDate: effectiveDate,
          ExpirationDate: expirationDate,
          RegionName: stateLicenseType.RegionName,
          LicenseName: stateLicenseType.LicenseName,
        }
      }));
    }

    case POST_LICENSE_START:
      return applyByKey(key, state, () => (
        { posting: true }
      ));

    case POST_LICENSE_SUCCESS:
      return applyByKey(key, state, () => (
        { posting: false }
      ));

    case POST_LICENSE_RESET:
      return applyByKey(key, state, () => (
        { posting: undefined }
      ));

    case EDIT_LICENSE_START:
      return applyByKey(key, state, () => (
        { posting: true }
      ));

    case EDIT_LICENSE_SUCCESS:
      return applyByKey(key, state, () => (
        { posting: false }
      ));

    case DELETE_LICENSE_START:
      return applyByKey(key, state, () => (
        { posting: true }
      ));

    case DELETE_LICENSE_SUCCESS:
      return applyByKey(key, state, () => (
        { posting: false }
      ));

    default:
      return state;
  }
}
